










import Vue from 'vue'

import Version  from '@/components/version.vue'
import Love     from '@/components/made-with-love.vue';
import Terms    from '@/components/terms.vue';

export default Vue.extend({
    components: { 
        version: Version ,
        'made-with-love': Love,
        Terms,
    }
})
